import React from 'react';
import { Callout, List, Only, P, Path, Steps, Sub, UI } from '../ui';

export const Settings: React.FC = () => (
  <>
    <P>
      왼쪽 탭 바 맨 아래의 <b>내 프로필 사진</b>을 클릭하고 <UI>프로필 설정</UI>을 누르면{' '}
      <UI>프로필 아이콘 설정</UI> 창이 열립니다. 모바일에서는 화면 아래 <UI>설정</UI> 탭 &rarr; <UI>프로필 수정</UI>입니다
      (홈 화면 오른쪽 위 내 사진을 눌러도 설정 탭으로 이동합니다).
    </P>

    <Sub>내 사진으로 바꾸기</Sub>
    <Steps>
      <>
        <Path items={['왼쪽 탭 바 맨 아래 내 사진', '프로필 설정']} /> 을 클릭합니다.
      </>
      <>
        <UI>내 사진 선택</UI>을 누르고 사진 파일을 고릅니다.
      </>
      <>
        편집 창에서 사진을 <b>끌어 위치를 맞추고</b>, 아래 막대로 크기를 조절합니다. 회전 버튼으로 90도씩 돌릴 수
        있고, <b>사진 효과</b>(흑백·세피아·선명·밝게·만화풍)를 골라 볼 수 있습니다.
      </>
      <>
        <UI>적용</UI>을 눌러 편집을 마친 뒤, <UI>저장</UI>까지 눌러야 반영됩니다.
      </>
    </Steps>
    <Callout tone="info">
      <p>
        올릴 수 있는 사진은 <b>JPG · PNG · WEBP</b>이고 <b>20MB 이하</b>입니다. 잘라낸 사진은 정사각형으로 저장됩니다.
      </p>
      <p>
        저장하면 예전에 보낸 메시지에 붙어 있던 사진까지 <b>모든 사람 화면에서 즉시 바뀝니다.</b> 내가 쓰는 다른
        기기에도 바로 반영됩니다.
      </p>
      <p>이름과 부서는 인트라넷 계정 정보를 그대로 가져오므로 앱에서 바꿀 수 없습니다.</p>
    </Callout>

    <Sub>준비된 아이콘 쓰기</Sub>
    <P>
      사진 대신 미리 준비된 20가지 아이콘 중에서 골라도 됩니다. 선택한 아이콘에는 테두리와 체크 표시가 붙고,{' '}
      <UI>저장</UI>을 누르면 반영됩니다. 사내에서 접근 가능한 <b>이미지 주소(URL)</b>가 있다면 아래 칸에 붙여넣고{' '}
      <UI>적용</UI>을 눌러도 됩니다.
    </P>

    <Sub>알림에 표시할 내용</Sub>
    <P>
      설정 창의 <UI>알림</UI> 항목에서 알림 팝업에 <b>전체 표시 · 보낸 사람만 · 전부 숨김</b> 중 무엇을 보여줄지
      고를 수 있습니다. 기본값은 전체 표시이고, 기기가 아니라 계정에 저장되어 로그인한 모든 기기에 함께
      적용됩니다. 자세한 내용은 <b>알림</b> 도움말을 참고하세요.
    </P>

    <Sub>내 상태</Sub>
    <P>
      왼쪽 탭 바 맨 아래의 내 프로필 사진을 클릭하면 맨 위에 <UI>접속중 (자동)</UI>·<UI>자리 비움</UI>·
      <UI>다른 용무 중</UI> 세 항목이 있습니다. 모바일에서는 <UI>설정</UI> 탭 &rarr; <UI>내 상태</UI>입니다. 고른
      상태는 동료의 대화방 목록·온라인 탭·채팅방 이름 옆 점 색으로 함께 바뀝니다.
    </P>
    <List>
      <>
        <b>접속중 (자동)</b> — 기본값. <b>5분 동안 PC를 쓰지 않거나 화면을 잠그면 자동으로 자리 비움</b>이 되고,
        키보드나 마우스를 다시 쓰면 곧 접속 중으로 돌아옵니다.
      </>
      <>
        <b>자리 비움</b> — PC를 쓰는 중이어도 자리 비움으로 보입니다.
      </>
      <>
        <b>다른 용무 중</b> — 표시만 바뀝니다. 알림은 그대로 옵니다.
      </>
    </List>
    <Callout tone="tip">
      <p>
        직접 고른 상태는 <b>접속 중에만 유지됩니다.</b> PC 앱과 휴대폰을 모두 종료하면 다음에 켤 때{' '}
        <UI>접속중 (자동)</UI>으로 돌아오므로, 해제하는 것을 잊어 계속 &lsquo;다른 용무 중&rsquo;으로 남는 일이
        없습니다.
      </p>
    </Callout>

    <Sub>데스크톱 설정 <Only env="desktop" /></Sub>
    <P>PC 앱에서는 설정 창 아래쪽에 세 가지 항목이 더 표시됩니다.</P>
    <List>
      <>
        <b>PC 시작 시 자동 실행</b> — 켜두면 Windows에 로그인할 때 INA-TALK이 트레이에서 조용히 실행됩니다. 창이
        따로 뜨지 않아 방해가 되지 않으면서 알림은 정상적으로 받습니다. <b>기본값은 켜짐</b>입니다.
      </>
      <>
        <b>로그아웃 시에도 알림 받기</b> — 로그아웃 상태에서 새 메시지 도착 여부만 알려줍니다. 발신자와 내용은
        표시되지 않습니다. <b>기본값은 켜짐</b>입니다.
      </>
      <>
        <b>앱 업데이트</b> — 최신 버전을 직접 확인하고 설치합니다.
      </>
    </List>

    <Sub>로그아웃</Sub>
    <P>
      왼쪽 탭 바 맨 아래의 내 프로필 사진을 클릭하고 <UI>로그아웃</UI>을 누릅니다(모바일은 <UI>설정</UI> 탭 맨 아래
      로그아웃 버튼). 다시 로그인하려면 인트라넷 아이디와 비밀번호를 입력하면 됩니다. PC 앱에서 직접 로그아웃하면{' '}
      <UI>자동 로그인</UI>이 꺼지고 아이디만 채워진 로그인 화면이 뜹니다.
    </P>
    <Callout tone="tip">
      <p>
        공용 PC를 쓴다면 자리를 뜰 때 로그아웃하세요. PC 앱이라면 로그아웃 상태에서도 &ldquo;새 메시지가
        도착했습니다&rdquo; 알림만 받을 수 있어, 내용은 감추면서 연락 여부는 확인할 수 있습니다. 웹·모바일은
        로그아웃 확인 창의 &ldquo;로그아웃 후에도 알림 받기&rdquo; 체크로 같은 기능을 선택할 수 있습니다 &mdash;
        공용 PC라면 체크를 해제하고 로그아웃하세요.
      </p>
    </Callout>

    <Sub>제공하지 않는 설정</Sub>
    <P>다음 기능은 현재 지원하지 않습니다.</P>
    <List>
      <>어두운 테마(다크 모드) 전환</>
      <>글꼴 크기 변경</>
      <>알림음 변경</>
      <>내가 로그인한 기기 목록 확인·해제</>
    </List>
  </>
);
